<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div><el-divider>短信提醒设置</el-divider></div>
        <div style="padding: 10px;display: flex;align-items: center;">
          <div style="font-size: 20px;">当前短信提醒功能:
            <span>
              <span v-if="can_send_short_message=='1'" style="color:green;">{{getStateLabel()}}</span>
              <span v-else style="color: red;">{{getStateLabel()}}</span>
            </span>
          </div>

          <div style="margin-left: 100px;">
            <div v-if="can_send_short_message=='1'"><el-button @click="closeNotify" type="danger">关闭提醒</el-button>
            </div>
            <div v-else><el-button @click="openNotify" type="primary">打开提醒</el-button></div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  export default {
    components: {
      MenuList,
      Header
    },
    created() {
      this.username = this.$session.get('USERNAME') // 获取session

      this.loadShotMessageState()
    },
    data() {
      return {
        can_send_short_message: '1',
        username: ''
      }
    },
    methods: {
      getStateLabel() {
        var label = ''
        if (this.can_send_short_message == '1') {
          label = '打开状态'
        } else {
          label = '关闭状态'
        }

        return label
      },
      closeNotify() {
        this.$confirm('confirmTitle', "提示", {
          message: '关闭提醒后将收不到任何关于平台的短信提醒,确定要关闭吗?',
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        }).then(() => {
          // this.addColumnIndex = index
          // this.courseForm.course_type = ''
          // this.courseForm.course_name = cellValue

          // this.addCourseDialogVisible = true
          this.saveSendMessageState('ADD_IN_BLACK')
          console.log('已经关闭')
          this.can_send_short_message='0'

          this.$message({

            type: "info",

            message: "短信提醒已经关闭成功！"

          });

        }).catch(() => {

          // this.$message({

          //   type: "info",

          //   message: "已取消退出"

          // });

        });
      },
      openNotify() {
        this.$confirm('confirmTitle', "提示", {
          message: '打开提醒后将会收到平台短信各类提醒,确定要打开吗?',
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        }).then(() => {
          // this.addColumnIndex = index
          // this.courseForm.course_type = ''
          // this.courseForm.course_name = cellValue

          // this.addCourseDialogVisible = true
          this.saveSendMessageState('REMOVE_FROM_BLACK')
          // console.log('已经打开')
          this.can_send_short_message='1'

          this.$message({

            type: "info",

            message: "短信提醒已经打开成功！"

          });

        }).catch(() => {

          // this.$message({

          //   type: "info",

          //   message: "已取消退出"

          // });

        });
      },
      loadShotMessageState() {
        let that = this
        var requestUrl = '/score/web/_load_short_message_state.jsp'
        this.axios.get(requestUrl, {
            params: {
              username: that.username
            }
          }).then(function(response) {
            var is_black_user = response.data.is_black_user
            if (is_black_user == '1') {
              that.can_send_short_message = '0' //关闭
            } else {
              that.can_send_short_message = '1'
            }

          })
          .catch(function(error) {
            console.log(error)
          })
      },
      saveSendMessageState(action_str) {
        let that = this

        var requestUrl = '/score/web/_save_black_user.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: this.username,
              action: action_str
            }
          }).then(function(response) {
            // that.$message('操作成功！')

          })
          .catch(function(error) {
            console.log(error)
          })
      },

    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/short_message_setting.vue